import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_3 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", null, "システム設定", -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _ctx.getSystem,
        loading: _ctx.loading,
        color: "primary",
        variant: "outlined"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-sync", -1)
            ]))]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createTextVNode(" 更新 ", -1))
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    (_ctx.systemResponse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_card, { variant: "outlined" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("CCS HOME", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { align: "center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: _ctx.views.titleCols
                          }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createElementVNode("h4", null, "保護者からのチャット送信許可", -1)
                            ]))]),
                            _: 1
                          }, 8, ["cols"]),
                          _createVNode(_component_v_col, {
                            cols: _ctx.views.textCols
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_switch, {
                                modelValue: _ctx.systemResponse.chat.isEnabled,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.systemResponse.chat.isEnabled) = $event)),
                                disabled: _ctx.loading,
                                color: "primary"
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["cols"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_row, {
        align: "center",
        justify: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                onClick: _ctx.updateSystem,
                disabled: _ctx.loading,
                color: "primary",
                variant: "flat",
                block: ""
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" 保存 ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}